var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.302,
    height: 14.978,
    viewBox: "0 0 21.302 14.978",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34853",
    "data-name": "Group 34853",
    transform: "translate(-1105.345 1215.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34215",
    "data-name": "Path 34215",
    d: "M1126.648-1201.728a4.273,4.273,0,0,1-.2.584,1.827,1.827,0,0,1-1.612,1.036c-.055,0-.111,0-.166,0H1107.3a1.866,1.866,0,0,1-1.886-1.393,2.132,2.132,0,0,1-.066-.533q-.005-5.563,0-11.125a1.866,1.866,0,0,1,1.933-1.925q8.713,0,17.426,0a1.861,1.861,0,0,1,1.906,1.526.82.82,0,0,0,.036.1Zm-19.122-12.095c.065.069.106.114.149.157l7.724,7.747a.741.741,0,0,0,1.2-.005l7.724-7.747c.042-.042.081-.088.141-.152Zm-.012,12.451h16.967l-5.354-5.307c-.041.039-.1.089-.149.142-.519.52-1.036,1.043-1.557,1.561a1.968,1.968,0,0,1-2.847,0c-.315-.313-.626-.629-.939-.943l-.765-.764Zm-.911-.95,5.33-5.277-5.33-5.284Zm18.778.041v-10.555l-5.33,5.271Z",
    fill: "#f2b31b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9d21af62961216ceb17830b32d61cbec.svg";
export { ForwardRef as ReactComponent };